export const primaryInputStyleClassName =
  "min-w-[40px] max-h-[40px] flex-grow border-gray-400 border-2 py-1 px-2 focus:border-violet-500 focus:outline-none rounded-md";
